import Swal from "sweetalert2";

const deleteBtn = document.querySelector('.deleteBtn');
const btnDelete = document.querySelector('.btnDelete');
const btnDeactivate = document.querySelector('.btnDeactivate');
const btnDeleteUser = document.querySelector('.btnDeleteUser');
const deleteAddressBtn = document.querySelector('.deleteAddressBtn');

const removeItem = document.querySelector('.removeItem');


document.addEventListener('DOMContentLoaded', function () {

    if (deleteBtn) {
        deleteBtn.addEventListener('click', function (e) {
            e.preventDefault();

            const form = this.closest('form');

            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.isConfirmed) {
                    form.submit();
                }
            });
        })
    }

    if (btnDelete) {
        btnDelete.addEventListener('click', function (e) {
            e.preventDefault();

            const form = this.closest('form');

            Swal.fire({
                title: "Jeste li sigurni?",
                text: "Ova radnja se ne može poništiti.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD7A37",
                confirmButtonText: "Obriši račun",
                cancelButtonText: "Poništi",
                reverseButtons: true,
                customClass: {
                    popup: "customSwal",
                    title: "swalTitle",
                    confirmButton: "swalBtnConfirm",
                    cancelButton: "swalBtnCancel"
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    form.submit();
                }
            });
        })
    }

    if (deleteAddressBtn) {
        deleteAddressBtn.addEventListener('click', function (e) {
            e.preventDefault();

            const form = this.closest('form');

            Swal.fire({
                title: "Jeste li sigurni?",
                text: "Ova radnja se ne može poništiti.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD7A37",
                confirmButtonText: "Obriši adresu",
                cancelButtonText: "Poništi",
                reverseButtons: true,
                customClass: {
                    popup: "customSwal",
                    title: "swalTitle",
                    confirmButton: "swalBtnConfirm",
                    cancelButton: "swalBtnCancel"
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    form.submit();
                }
            });
        })
    }

    if (btnDeactivate) {
        btnDeactivate.addEventListener('click', function (e) {
            e.preventDefault();

            const form = this.closest('form');

            Swal.fire({
                title: "Jeste li sigurni?",
                text: "Ova radnja se ne može poništiti.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD7A37",
                confirmButtonText: "Pošalji zahtjev",
                cancelButtonText: "Poništi",
                reverseButtons: true,
                customClass: {
                    popup: "customSwal",
                    title: "swalTitle",
                    confirmButton: "swalBtnConfirm",
                    cancelButton: "swalBtnCancel"
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    form.submit();
                }
            });
        })
    }

    if (btnDeleteUser) {
        btnDeleteUser.addEventListener('click', function (e) {
            e.preventDefault();

            const form = this.closest('form');

            Swal.fire({
                title: "Jeste li sigurni?",
                text: "Ova radnja se ne može poništiti.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD7A37",
                confirmButtonText: "Obriši korisnika",
                cancelButtonText: "Poništi",
                reverseButtons: true,
                customClass: {
                    popup: "customSwal",
                    title: "swalTitle",
                    confirmButton: "swalBtnConfirm",
                    cancelButton: "swalBtnCancel"
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    form.submit();
                }
            });
        })
    }
});
